export const getWindowResolution = (): [number, number] => {
  const offsetRatioWidth = document.body.offsetWidth * window.devicePixelRatio;
  const offsetRatioHeight =
    document.body.offsetHeight * window.devicePixelRatio;

  return [
    offsetRatioWidth - (offsetRatioWidth % 2),
    offsetRatioHeight - (offsetRatioHeight % 2),
  ];
};

export const isIOSChrome = (): boolean => /CriOS/.test(navigator.userAgent);
